class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.querySelectorAll('.cart-notification__close').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    document.getElementById('sticky-atc-bar').classList.add('lower-z-index');
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.getElementById('sticky-atc-bar').classList.remove('lower-z-index');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        let sectionSelector = section.selector;
        if (sectionSelector == '[id="cart-notification-product-undefined"]') {
          document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id]);
        } else if (parsedState.sections !== null) {
          document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], sectionSelector);
        }
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    let quickAddModal = document.querySelector('.quick-add-modal__content-info');
    let quickAddCloseModal = document.querySelector('.quick-add-modal__toggle');
    if (target !== this.notification && !target.closest('cart-notification') && 
    target !== quickAddModal && !target.closest('.quick-add-modal__content-info') &&
    target !== quickAddCloseModal) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
